// extracted by mini-css-extract-plugin
export var addButton = "_pl-0";
export var border = "_pl-8";
export var check = "_pl-h";
export var danger = "_pl-6";
export var dropdownContainer = "_pl-1";
export var editModalBody = "_pl-j";
export var footerContainer = "_pl-i";
export var fullWidth = "_pl-a";
export var hide = "_pl-9";
export var icon = "_pl-3";
export var input = "_pl-7";
export var inputFlex = "_pl-b";
export var inputWrapper = "_pl-c";
export var manualFocus = "_pl-5";
export var optionButton = "_pl-4";
export var pillWrapper = "_pl-e";
export var pointer = "_pl-2";
export var showOverflow = "_pl-f";
export var tagsFlex = "_pl-d";
export var xButton = "_pl-g";